<script>
  import DropDown from '../DropDown.svelte';
  import AddTaskModal from '../AddTaskModal.svelte';
  import EditTaskModal from '../EditTaskModal.svelte';
  import GridSearch from '../GridSearch.svelte';
  import CreateGroup from './CreateGroup.svelte';
  import TaskTemplatesModal from '../TaskDashboard/TaskTemplatesModal.svelte';
  import FullCalendar from 'components/FullCalendar.svelte';
  import TaskAssigneeFilter from './TaskAssigneeFilter.svelte';
  import { Modal } from 'bootstrap';
  import DataTable from '../DataTable/DataTable.svelte';
  import { client } from 'root/api/index.js';
  import { onMount, getContext, setContext, onDestroy } from 'svelte';
  import TaskReasonModal from '../TaskReasonModal.svelte';
  import TaskChangeAssignee from '../TaskChangeAssignee.svelte';
  import { Popover } from 'bootstrap';
  import ReadMore from 'components/ReadMore/ReadMore.svelte';
  import ReportFilter from './ReportFilter.svelte';

  const showDialog = getContext('showDialog');
  export let setDashboardFilter;
  export let dashboardLeftObj;

  let taskReasonModal;
  let taskChangeAssigneeModal;
  import {
    downloadCsvFile,
    searchKeyByValue,
    configItem,
    dbDateFormat,
    cloneArray,
    startMonthDateFormat,
    getValueBySearchValue,
  } from 'components/Helper.js';
  let calendarComponentRef;
  let firstTimeCalendarLoad = true;
  let moreEventsPopover = null;

  // popover styling
  const POPOVER_WIDTH = 280;
  const POPOVER_BODY_MAX_HEIGHT = 260;
  const POPOVER_HEADER_HEIGHT = 28;
  const POPOVER_OFFSET = 6;

  const handleMoreLinkClick = ({ x, y, hiddenEvents }) => {
    const popoverHeight =
      POPOVER_HEADER_HEIGHT + Math.min(hiddenEvents.length * 34, POPOVER_BODY_MAX_HEIGHT);
    const clampedX = Math.min(x + POPOVER_OFFSET, window.innerWidth - POPOVER_WIDTH - 10);
    const fitsBelow = y + POPOVER_OFFSET + popoverHeight < window.innerHeight;
    const clampedY = fitsBelow ? y + POPOVER_OFFSET : y - popoverHeight - POPOVER_OFFSET;
    moreEventsPopover = { x: Math.max(clampedX, 10), y: Math.max(clampedY, 10), hiddenEvents };
  };

  const closeMoreEventsPopover = () => {
    moreEventsPopover = null;
  };

  let showBulkOption = true;
  let calenderButton = false;
  let openDueDateModal;
  import OpenDueDateModal from './../../components/OpenDueDateModal.svelte';

  const downloadCsv = () => {
    let filterDataCsv = { ...extraFilter };
    if (showBulkOption == false && extraFilter.comeFrom == 'calendar') {
      filterDataCsv.comeFrom = 'calendar';
      filterDataCsv.fromDate = dbDateFormat(calenderInfo.start);
      filterDataCsv.toDate = dbDateFormat(calenderInfo.end);
    }
    client
      .exportTaskList({
        ...filterDataCsv,
      })
      .then(async (result) => {
        downloadCsvFile(result, 'task_schedule.csv');
      });
  };
  let datatableRef;
  let scrollRef;

  let checkBoxSelected = false;
  const handleCheckbox = (e) => {
    checkBoxSelected = e.target.checked;
    if (checkBoxSelected) {
      selectedTasks = datatableRef.getValues().map((item) => {
        return { id: item.id };
      });
    } else {
      selectedTasks = [];
    }
  };

  let idObj = {
    key: 'id',
    label: 'Id',
    sortable: true,
    checked: true,
    handleCheckbox: handleCheckbox,
    width: 20,
  };

  let allColumns = [
    idObj,
    { key: 'priority', label: 'Priority', sortable: true, checked: true, width: 20 },
    { key: 'riskRank', label: 'Risk Rank', sortable: true, checked: true, width: 20 },
    { key: 'unitName', label: 'Business Unit', sortable: true, checked: true, width: 140 },
    { key: 'name', label: 'Task', sortable: true, checked: true, width: 0 },
    { key: 'purpose', label: 'Purpose', sortable: true, checked: true, width: 0 },
    { key: 'requirement', label: 'Requirement', sortable: true, checked: true, width: 0 },
    {
      key: 'responsibleParty',
      label: 'Responsible Party',
      sortable: true,
      checked: true,
      width: 140,
    },
    { key: 'assigneeUserName', label: 'Assignee Name', sortable: true, checked: true, width: 120 },
    { key: 'clientName', label: 'Client', sortable: true, checked: true, width: 120 },
    { key: 'clientFundProfileName', label: 'Funds', sortable: true, checked: true, width: 120 },
    { key: 'recurring', label: 'Frequency', sortable: true, checked: true, width: 120 },
    { key: 'unitProjectName', label: 'Internal', sortable: true, checked: true, width: 120 },
    { key: 'openDate', label: 'Open Date', sortable: true, checked: true, width: 90 },
    { key: 'dueDate', label: 'Due Date', sortable: true, checked: true, width: 90 },
    { key: 'status', label: 'Task Status', sortable: true, checked: true, width: 130 },
    {
      key: 'complianceStatus',
      label: 'Compliance Status',
      sortable: true,
      checked: true,
      width: 130,
    },
    { key: 'clone', label: 'Clone', sortable: false, checked: true, width: 20 },
  ];

  let columns = [...allColumns];
  let defaultFilter = {
    searchKeyword: '',
    schedule: 1,
    taskType: '',
    outForCollabrator: 0,
    overdue: 0,
    requireReview: 0,
    isManager: 0,
    unitProjectId: '',
    recurringType: '',
    units: [],
    users: [],
    clients: [],
    status: '',
    fromDate: '',
    toDate: '',
    requestKey: 0,
    calenderType: '',
    comeFrom: '',
    recurringType: '',
    unitRegistrationTypeIds: [],
    taskActivityTypes: [],
    priority: [],
    taskRiskRankType: [],
    taskServiceType: [],
  };
  let extraFilter = { ...defaultFilter };

  $: extraFilter && filterData();
  $: extraFilter && showFilterButton();
  let filterSelected = false;

  let filterButton = false;
  const showFilterButton = () => {
    filterButton =
      JSON.stringify({ ...defaultFilter, units: [], requestKey: 0 }) !=
      JSON.stringify({ ...extraFilter, units: [], requestKey: 0 });
  };

  let totalRecords = '';
  let totalCount = '';

  let getCount = () => {
    let queries = {};
    client
      .taskCount({
        ...queries,
        ...defaultFilter,
        units: extraFilter.units,
        isManager: extraFilter.isManager,
        isTotalCount: 1,
      })
      .then((result) => {
        totalRecords = result.data.pagination.totalCount;
      });
  };

  let getListCount = () => {
    let queries = {};
    totalCount = '';
    client
      .taskList(50, 1, {
        ...queries,
        ...extraFilter,
      })
      .then((result) => {
        totalCount = result.totalCount;
      });
  };

  let getData = (queries) => {
    checkBoxSelected = false;
    filter = {
      ...extraFilter,
    };
    return client.taskList(50, 1, {
      ...queries,
      ...extraFilter,
      fromDate: '',
      toDate: '',
    });
  };

  export const checkUrl = (params) => {
    if (params.action == 'scheduleTask' && params.userId != undefined) {
      extraFilter = {
        ...extraFilter,
        users: [{ id: params.userId, userId: params.userId }],
        units: [{ id: params.unitId, unitId: params.unitId }],
      };
      setDashboardData({
        ...getDashboardData(),
        isManager: 1,
        users: [{ id: params.userId, userId: params.userId }],
        units: [{ id: params.unitId, unitId: params.unitId }],
        taskServiceType: [],
        taskActivityTypes: [],
      });
    } else if (params.action == 'scheduleTask' && params.openTaskId != undefined) {
      editTask(params.openTaskId, params.comeFrom);
    }
  };

  let assignee = [];

  let taskType = [
    { id: 1, text: 'Client' },
    { id: 2, text: 'Internal' },
  ];

  let bulkAction = [];
  let recurringTypeList = [];
  import { getUserInfo } from '../../stores/auth.js';
  import { masterData, getMasterData } from '../../stores/masterData.js';
  const unsubscribeMasterData = masterData.subscribe((state) => {
    client.checkAuth().then(() => {
      if (state != undefined) {
        let userRoleId = getUserInfo().roleId;
        let userRoles = getMasterData().userRoleId;
        let custom = {
          id: -1,
          name: 'As occurs',
        };
        recurringTypeList = state.recurringTypeLabel;
        recurringTypeList = [custom, ...recurringTypeList];
        let action = [];
        action.push({ id: 1, text: 'Change Assignee' });
        // if(userRoles.admin == userRoleId || userRoles.unit_admin == userRoleId)
        {
          action.push({ id: 2, text: 'Delete Task' });
        }
        action.push({ id: 3, text: 'Complete Task' });
        action.push({ id: 4, text: 'Change Open & Due Date' });
        action.push({ id: 5, text: 'Change Priority' });
        action.push({ id: 6, text: 'Change Risk Rank' });
        bulkAction = action;
      }
    });
  });

  let status = [
    { id: 1, text: 'Open' },
    { id: 2, text: 'Completed' },
  ];

  let id = 0;
  let addTaskModal;
  let editTaskModal;
  export const addTask = () => {
    addTaskModal.show();
  };
  const editTask = (taskId, comeFrom) => {
    editTaskModal.show(taskId, comeFrom);
  };

  let unitUsers = [];
  let clientUnitUsers = [];
  let registrationTypes = [];
  let taskActivityTypes = [];
  const getUnitDetail = async (comeFrom) => {
    let unitIds = [...extraFilter.units];
    unitIds.map((item) => {
      item.unitId = item.id;
      return item;
    });
    client
      .unitUsers({ units: unitIds, inactiveCondition: 'N', inactiveUnitCondition: 'N' })
      .then((response) => {
        let detail = response.data;
        unitUsers = detail.users.map((item) => {
          item.name = item.firstName + ' ' + item.lastName;
          item.checked = searchKeyByValue(extraFilter.users, 'id', item.userId) != -1;
          return item;
        });
      });
    client.getUnitProject({ units: unitIds }).then((response) => {
      projects = response.data.projects;
    });
    client.unitTaskClients({ units: unitIds }).then((response) => {
      clientUnitUsers = response.data.clients.map((item) => {
        item.checked = searchKeyByValue(extraFilter.clients, 'id', item.id) != -1;
        return item;
      });
    });
    if (unitIds.length > 0) {
      const result = await client.sowServiceType({ units: unitIds });
      taskServiceType = (result?.data?.payload || [])?.map?.((item) => {
        item.checked = extraFilter.taskServiceType?.some?.((service) => service.id === item.id);
        return item;
      });
      client.taskTemplateFilter({ units: unitIds }).then((response) => {
        taskActivityTypes = [
          { id: -1, name: 'No Type' },
          ...response.data.taskActivityTypes,
        ]?.map?.((item) => {
          item.checked = extraFilter.taskActivityTypes?.some?.(
            (activity) => activity.id === item.id,
          );
          return item;
        });
        registrationTypes = response.data.registrationTypes;

        if (comeFrom != undefined && comeFrom == 'filterSelected') {
          let oldRegistrationTypes = cloneArray(registrationTypes).map((userItem) => {
            userItem.checked =
              extraFilter.unitRegistrationTypeIds.length > 0 &&
              searchKeyByValue(extraFilter.unitRegistrationTypeIds, 'id', userItem.id) !== -1;
            return userItem;
          });
          let oldTaskActivityTypes = cloneArray(taskActivityTypes).map((userItem) => {
            userItem.checked =
              extraFilter.taskActivityTypes.length > 0 &&
              searchKeyByValue(extraFilter.taskActivityTypes, 'id', userItem.id) !== -1;
            return userItem;
          });
          setTimeout(() => {
            registrationTypes = oldRegistrationTypes;
            taskActivityTypes = oldTaskActivityTypes;
          }, 1000);
        }
      });
    }
  };

  let searchTimeout;
  let searchCloneTimeout;
  let firstTimeLoad = true;
  let filterData = () => {
    if (searchTimeout != undefined) {
      clearTimeout(searchTimeout);
    }
    if (searchCloneTimeout != undefined) {
      clearTimeout(searchCloneTimeout);
    }
    searchTimeout = setTimeout(() => {
      if (extraFilter.comeFrom == 'calender') {
        if (calendarComponentRef != undefined) {
          if (firstTimeCalendarLoad) {
            firstTimeCalendarLoad = false;
            searchCloneTimeout = setTimeout(() => {
              initPopupOver();
            }, 400);
            return false;
          }
          calendarComponentRef.refetchEvents();
        }
      } else {
        if (datatableRef != undefined) {
          getCount();
          getListCount();
          if (firstTimeLoad) {
            firstTimeLoad = false;
            searchCloneTimeout = setTimeout(() => {
              initPopupOver();
            }, 400);
            return false;
          }
          selectedTasks = [];
          datatableRef.initializeState();
          searchCloneTimeout = setTimeout(() => {
            initPopupOver();
          }, 400);
        }
      }
    }, 500);
  };

  const initPopupOver = () => {
    var tooltipElements = document.querySelectorAll('.popover.show');
    tooltipElements.forEach(function (el) {
      var existing = Popover.getInstance(el);
      if (existing) {
        existing.dispose();
      }
      el.remove();
    });
    var elements = document.querySelectorAll('.clone_popup');
    elements.forEach(function (el) {
      new Popover(el, { container: el.parentElement, animation: false });
    });
  };

  let selectedTasks = [];
  let assignType = 1;
  let projects = [];

  let changePriorityModal;
  let changeRiskRankModal;

  import ChangePriorityModal from './../../components/ChangePriorityModal.svelte';
  import ChangeRiskRankModal from './../../components/ChangeRiskRankModal.svelte';

  // Type ids series - will show the heading options only based on these ids
  const updateAssigneeSchedule = 1;
  const deleteTaskSchedule = 2;
  const updateRiskRankSchedule = 6;

  let selectedTypeId;
  let comeFromDetail = false;
  const taskBulkAction = (typeId, comeFromBulk) => {
    const headersTaskSeries = [updateAssigneeSchedule, deleteTaskSchedule, updateRiskRankSchedule];
    comeFromDetail = comeFromBulk;
    selectedTypeId = typeId;
    if (selectedTasks.length > 0) {
      showDialog({
        isDeleteModel: typeId == 2,
        type: 'confirm',
        title: '',
        isHtmlMessage: true,
        message:
          'Are you sure ?' +
          (typeId == 3
            ? '<br/><br/><small>Note: For recurring items, only the instance appearing/selected will be completed. All other future occurrences will remain.</small>'
            : ''),
        optionHeading: headersTaskSeries.includes(typeId)
          ? 'If this task is part of a series, do you want to:'
          : '',
        options: [updateAssigneeSchedule, updateRiskRankSchedule].includes(typeId)
          ? cloneArray(configItem.assignTypes)
          : typeId == 2
            ? cloneArray(configItem.deleteAssignTypes)
            : [],
        okFunc: (e) => {
          //change assignee
          if (typeId == 1 || typeId == 2) {
            assignType = e.selectedOptions.value;
          }
          if (typeId == 1) {
            taskChangeAssigneeModal.showModal({
              unitUsers,
              selectedTasks,
            });
          }
          //delete task
          if (typeId == 2) {
            taskReasonModal.showModal();
          }
          //comeplete task
          if (typeId == 3) {
            client
              .taskComplete({ tasks: selectedTasks })
              .then(async (result) => {
                selectedTasks = [];
                filterData();
              })
              .catch((err) => {
                showDialog({ message: err.message, isHtmlMessage: true });
              });
          }

          //delete task
          if (typeId == 4) {
            openDueDateModal.show({ comeFrom: 'bulk', dateType: 'openDate', tasks: selectedTasks });
          }
          //priority task
          if (typeId == 5) {
            changePriorityModal.show({ tasks: selectedTasks, priority: 2 });
          }
          //risk rank task change
          if (typeId == 6) {
            changeRiskRankModal.show({
              tasks: selectedTasks,
              riskRank: 2,
              assignType: e.selectedOptions.value,
            });
          }
        },
      });
    } else {
      showDialog({
        title: '',
        message: 'Please select task',
      });
    }
  };

  setContext('taskAction', (params) => {
    if (params.type == 'saveTask') {
      filterData();
      if (params.id > 0 && !(params.values != undefined && params.values.status == 2)) {
        return;
      }
    }
    if (params.type == 'deleteTask') {
      selectedTasks = [{ id: params.id }];
      taskBulkAction(2, true);
      return;
    }
    if (editTaskModal != undefined) {
      editTaskModal.hide();
    }
    if (addTaskModal != undefined) {
      addTaskModal.hide();
    }
  });

  import { dashboardData, getDashboardData, setDashboardData } from '../../stores/dashboard.js';
  const unsubscribe = dashboardData.subscribe((dataState) => {
    client.checkAuth().then(() => {
      if (dataState != undefined) {
        let state = { ...dataState };
        let oldExtraFilter = { ...extraFilter };
        let loadUnit = false;
        if (JSON.stringify(oldExtraFilter.units) != JSON.stringify(state.units)) {
          oldExtraFilter.units = [...state.units];
          loadUnit = true;
        }
        if (JSON.stringify(oldExtraFilter.clients) != JSON.stringify(state.clients)) {
          oldExtraFilter.clients = [...state.clients];
        }
        if (JSON.stringify(oldExtraFilter.users) != JSON.stringify(state.users)) {
          oldExtraFilter.users = [...state.users];
        }
        oldExtraFilter.taskRiskRankType = state.taskRiskRankType;
        oldExtraFilter.taskServiceType = state.taskServiceType;
        oldExtraFilter.taskActivityTypes = state.taskActivityTypes;
        oldExtraFilter.requestKey++;
        oldExtraFilter.fromDate = state.fromDate;
        oldExtraFilter.toDate = state.toDate;
        oldExtraFilter.isManager = state.isManager;
        extraFilter = { ...oldExtraFilter };
        if (loadUnit) {
          getUnitDetail();
        } else {
          unitUsers = unitUsers.map((item) => {
            item.checked = searchKeyByValue(extraFilter.users, 'id', item.userId) != -1;
            return item;
          });
          clientUnitUsers = clientUnitUsers.map((item) => {
            item.checked = searchKeyByValue(extraFilter.clients, 'id', item.id) != -1;
            return item;
          });
        }
      }
    });
  });
  let columnLoaded = false;
  onDestroy(() => {
    unsubscribe();
    unsubscribeMasterData();
  });
  onMount(() => {
    getUnitDetail();

    client.taskScheduleGridColumnList().then((response) => {
      let oldColumns = [];
      let hiddenColumn = [];
      let dbData = response.data.payload;
      let oldAllColumns = [...allColumns];
      for (var i in oldAllColumns) {
        let dbKey = searchKeyByValue(dbData, 'column_name', oldAllColumns[i].key);
        oldAllColumns[i].checked = true;
        if (dbKey !== -1) {
          if (dbData[dbKey].active == 1) {
            oldColumns.push(oldAllColumns[i]);
          } else {
            oldAllColumns[i].checked = false;
          }
        }
      }
      allColumns = oldAllColumns;
      columns = oldColumns;
      columnLoaded = true;
      setColumnUnitWidth();
    });
  });
  export let showClientModal;

  let availableWidth = 0;
  const setColumnUnitWidth = () => {
    let totalWidth = 220;
    columns.map((item) => {
      totalWidth += item.width;
    });
    availableWidth = window.screen.width - totalWidth;
    availableWidth = availableWidth < 100 ? 100 : availableWidth;
    let totalColumn = 0;
    if (searchKeyByValue(columns, 'key', 'purpose') != -1) {
      totalColumn++;
    }
    if (searchKeyByValue(columns, 'key', 'name') != -1) {
      totalColumn++;
    }
    if (searchKeyByValue(columns, 'key', 'requirement') != -1) {
      totalColumn++;
    }
    if (totalColumn > 0) {
      availableWidth /= totalColumn;
    }
  };

  let calenderInfo;
  let filter = {};
  function getEvents(info, successCallback, failureCallback) {
    calenderInfo = info;
    filter = {
      ...extraFilter,
      calenderFromDate: startMonthDateFormat(info.start),
      calenderToDate: dbDateFormat(info.end),
      comeFrom: 'calender',
    };
    client
      .taskList(50000, 1, {
        ...extraFilter,
        fromDate: dbDateFormat(info.start),
        toDate: dbDateFormat(info.end),
        comeFrom: 'calendar',
      })
      .then(async (result) => {
        totalCount = result.totalCount;
        let events = [];
        result.valueArray.map((item) => {
          let eventTitle = item.yearViewDate
            ? item.assigneeUserName + (item.duplicateCount ? ' (' + item.duplicateCount + ')' : '')
            : item.name;
          events.push({
            title: eventTitle,
            start: item.dueDateDb,
            classNames: item.isOverdue == 1 ? ['overdue-calendar-row'] : [],
            extendedProps: {
              id: item.id,
              title: eventTitle,
              duplicateCount: item.duplicateCount ? item.duplicateCount : 0,
              yearViewDate: item.yearViewDate ? item.yearViewDate : '',
              assigneeUserId: item.assigneeUserId ? item.assigneeUserId : '',
            },
          });
        });
        successCallback(events);
      });
    let queries = {};
    client
      .taskCount({
        ...defaultFilter,
        units: extraFilter.units,
        fromDate: dbDateFormat(info.start),
        toDate: dbDateFormat(info.end),
        pageNumber: 1,
        pageSize: 50000,
        comeFrom: 'calendar',
        isManager: extraFilter.isManager,
        isTotalCount: 1,
      })
      .then((result) => {
        totalRecords = result.data.pagination.totalCount;
      });
  }
  let heighlightTaskIds = [];

  const showLink = (flag) => {
    if (flag == 'list') {
      showBulkOption = true;
      // firstTimeGridLoad=true
      extraFilter.comeFrom = '';
      dashboardLeftObj.setTabIndex(1);
    } else if (flag == 'calender') {
      firstTimeCalendarLoad = true;
      extraFilter.comeFrom = 'calender';
      showBulkOption = false;
      extraFilter.recurringType = '';
      dashboardLeftObj.setTabIndex(1, 'calender');
      if (calendarComponentRef != undefined) {
        calendarComponentRef.updateSize();
      }
    }
  };
  let initialView = 'dayGridMonth';

  const resetFilter = () => {
    let oldUnitUsers = unitUsers;
    filterSelected = false;
    oldUnitUsers.map((item) => (item.checked = false));
    unitUsers = oldUnitUsers;
    extraFilter = {
      ...extraFilter,
      priority: [],
      users: [],
      taskType: '',
      clients: [],
      recurringType: '',
      searchKeyword: '',
      unitRegistrationTypeIds: [],
      taskActivityTypes: [],
      taskRiskRankType: [],
      taskServiceType: [],
    };
    setDashboardData({
      ...getDashboardData(),
      taskRiskRankType: [],
      taskServiceType: [],
      taskActivityTypes: [],
      clients: [],
      users: [],
    });
    configPriority = cloneArray(configItem.priority);
    registrationTypes = registrationTypes.map((item) => {
      item.checked = false;
      return item;
    });
    taskActivityTypes = taskActivityTypes.map((item) => {
      item.checked = false;
      return item;
    });
    // Reset risk rank filter
    taskRiskRankType = taskRiskRankType.map((item) => {
      item.checked = false;
      return item;
    });
    taskServiceType = taskServiceType.map((item) => {
      item.checked = false;
      return item;
    });
  };
  let configPriority = cloneArray(configItem.priority);
  let taskRiskRankType = configItem.riskRank;
  let taskServiceType = [];
</script>

<div class="filter-content top-menu-filter">
  <div class="d-flex flex-row mb-2 justify-content-between">
    <div class="d-flex flex-row">
      <TaskAssigneeFilter
        showDate={false}
        unitUsers={unitUsers}
        clientUnitUsers={clientUnitUsers}
        setDashboardFilter={setDashboardFilter}
        dashboardLeftObj={dashboardLeftObj}
        extraFilter={extraFilter}
        changeFilter={(filter) => {
          extraFilter = {
            ...extraFilter,
            ...filter,
          };
        }}
        type="2"
        showSaveButton={filterButton}
        filterSelected={filterSelected}
        filter={filter}
        on:filterSave={(item) => {
          filterButton = item.detail;
        }}
        on:filterSelected={(item) => {
          filterSelected = true;
          if (item.detail.filterData.calenderType) {
            initialView = extraFilter.calenderType;
          }
          extraFilter = item.detail.filterData;
          taskRiskRankType = taskRiskRankType?.map?.((item) => {
            item.checked = extraFilter.taskRiskRankType?.some?.((risk) => risk.id === item.id);
            return item;
          });
          getUnitDetail('filterSelected');
          let oldUnitUsers = cloneArray(unitUsers).map((userItem) => {
            userItem.checked =
              extraFilter.users.length > 0 &&
              searchKeyByValue(extraFilter.users, 'userId', userItem.userId) !== -1;
            return userItem;
          });
          let oldClientUnitUsers = cloneArray(clientUnitUsers).map((userItem) => {
            userItem.checked =
              extraFilter.clients.length > 0 &&
              searchKeyByValue(extraFilter.clients, 'id', userItem.id) !== -1;
            return userItem;
          });
          let oldConfigPriority = cloneArray(configPriority).map((userItem) => {
            userItem.checked =
              extraFilter.priority.length > 0 &&
              searchKeyByValue(extraFilter.priority, 'id', userItem.id) !== -1;
            return userItem;
          });
          setTimeout(() => {
            let notFoundUsers = extraFilter.users
              .filter((userItem) => {
                return searchKeyByValue(unitUsers, 'userId', userItem.id) == -1;
              })
              .map((userData) => {
                return userData.name;
              })
              .join(', ');
            let notFoundClient = extraFilter.clients
              .filter((userItem) => {
                return searchKeyByValue(clientUnitUsers, 'id', userItem.id) == -1;
              })
              .map((userData) => {
                return userData.name;
              })
              .join(', ');
            if (notFoundUsers != '' || notFoundClient != '') {
              let message = '';
              if (notFoundUsers != '') {
                message +=
                  ' Following users which are part of your report are no longer active:  ' +
                  notFoundUsers;
              }
              if (notFoundClient != '') {
                if (notFoundUsers != '') {
                  message += '<br /> ';
                }
                message +=
                  ' Following clients which are part of your report are no longer active:  ' +
                  notFoundClient;
              }
              showDialog({
                message,
                yesText: 'Continue',
              });
            }
          }, 500);

          setDashboardData({
            ...getDashboardData(),
            taskRiskRankType: extraFilter.taskRiskRankType,
            taskServiceType: extraFilter.taskServiceType,
            taskActivityTypes: extraFilter.taskActivityTypes,
            units: extraFilter.units,
            isManager: extraFilter.isManager,
            clients: extraFilter.clients.length > 0 ? extraFilter.clients : [],
            users: extraFilter.users.length > 0 ? extraFilter.users : [],
            fromDate: extraFilter.fromDate,
            toDate: extraFilter.toDate,
          });
          setTimeout(() => {
            configPriority = oldConfigPriority;
            // unitUsers=oldUnitUsers
            // clientUnitUsers=oldClientUnitUsers
            if (extraFilter.comeFrom == 'calender') {
              document
                .getElementById('profile-tab2')
                .setAttribute('calenderFromDate', extraFilter.calenderFromDate);
              document.getElementById('profile-tab2').click();
              setTimeout(() => {
                if (extraFilter.calenderType) {
                  if (extraFilter.calenderType && extraFilter.calenderType == 'timelineCustom') {
                    document.getElementById('btn-calender-year').click();
                  } else {
                    document.getElementById('btn-calender-month').click();
                  }
                } else {
                  document.getElementById('btn-calender-month').click();
                }
              }, 1000);
            } else {
              document.getElementById('home-tab2').click();
            }
          }, 500);
        }}
        on:clearFilter={() => {
          resetFilter();
        }}
      />
    </div>

    <GridSearch
      btnExport={true}
      value={extraFilter.searchKeyword}
      handleInput={(e) => {
        extraFilter.searchKeyword = e.target.value;
      }}
      selectedTasks={selectedTasks}
      onAction={(params) => {
        if (params == 'export') {
          downloadCsv();
        }
        if (params == 'delete') {
          alert('delete');
        }
      }}
      placeholder="Search Task"
    />
  </div>

  <div class="d-flex flex-row">
    <div class="left-action-bar w-100">
      <div class="d-flex flex-row align-items-center">
        {#if showBulkOption}
          <DropDown
            checkbox={false}
            active={true}
            title="Action"
            titleClass="text-primary"
            on:onSelect={(item) => {
              taskBulkAction(item.detail.id);
            }}
            option={bulkAction}
            Style="select-block bulk-action-drop"
          />
        {/if}

        <DropDown
          title={extraFilter.taskType == undefined || extraFilter.taskType == ''
            ? 'Client/Internal'
            : taskType[extraFilter.taskType - 1].text}
          option={taskType}
          Style="select-block"
          titleChanged={true}
          on:onSelect={(event) => {
            extraFilter.taskType = event.detail.id;
          }}
        />

        {#if extraFilter.taskType == 2}
          <DropDown
            defaultTitle="All Project"
            title={extraFilter.unitProjectId != undefined &&
            extraFilter.unitProjectId > 0 &&
            searchKeyByValue(projects, 'id', extraFilter.unitProjectId) != -1
              ? projects[searchKeyByValue(projects, 'id', extraFilter.unitProjectId)].name
              : 'All Project'}
            searchbox={true}
            option={projects}
            Style="select-block"
            titleChanged={true}
            on:onSelect={(event) => {
              extraFilter.unitProjectId = event.detail.id;
            }}
          />
        {/if}
        {#if showBulkOption}
          <DropDown
            defaultTitle="Frequency"
            title={extraFilter.recurringType != undefined &&
            extraFilter.recurringType > 0 &&
            searchKeyByValue(recurringTypeList, 'id', extraFilter.recurringType) != -1
              ? recurringTypeList[
                  searchKeyByValue(recurringTypeList, 'id', extraFilter.recurringType)
                ].name
              : 'Frequency'}
            option={recurringTypeList}
            Style="select-block"
            titleChanged={true}
            on:onSelect={(event) => {
              extraFilter.recurringType = event.detail.id;
            }}
          />
        {/if}

        {#if extraFilter.units.length > 0}
          <DropDown
            searchbox={true}
            checkbox={true}
            checkedFields="checked"
            title="Registration type"
            option={registrationTypes}
            Style="select-block"
            titleChanged={true}
            removeIcon={true}
            on:onClear={(event) => {
              extraFilter.unitRegistrationTypeIds = [];
            }}
            on:onSelect={(event) => {
              extraFilter.unitRegistrationTypeIds = event.detail;
            }}
          />
          <!-- Service Type filter -->
          {#if taskServiceType.length > 0}
            <DropDown
              searchbox={true}
              checkbox={true}
              deleteSelected={true}
              titleChanged={false}
              title="Service Type"
              checkedFields="checked"
              removeIcon={true}
              option={taskServiceType}
              Style="select-block"
              on:onClear={() => {
                setDashboardData({
                  ...getDashboardData(),
                  taskServiceType: [],
                });
              }}
              on:onSelect={(item) => {
                setDashboardData({
                  ...getDashboardData(),
                  taskServiceType: item.detail,
                });
              }}
            />
          {/if}
          <DropDown
            searchbox={true}
            checkbox={true}
            checkedFields="checked"
            title="Activity Type"
            option={taskActivityTypes}
            Style="select-block"
            titleChanged={true}
            removeIcon={true}
            on:onClear={(event) => {
              setDashboardData({
                ...getDashboardData(),
                taskActivityTypes: [],
              });
            }}
            on:onSelect={(event) => {
              setDashboardData({
                ...getDashboardData(),
                taskActivityTypes: event.detail,
              });
            }}
          />
        {/if}
        <!-- Risk Rank filter -->
        <DropDown
          showIcon={true}
          checkbox={true}
          deleteSelected={true}
          titleChanged={false}
          active={true}
          title="Risk Rank"
          checkedFields="checked"
          removeIcon={true}
          on:onClear={() => {
            setDashboardData({
              ...getDashboardData(),
              taskRiskRankType: [],
            });
          }}
          on:onSelect={(item) => {
            setDashboardData({
              ...getDashboardData(),
              taskRiskRankType: item.detail,
            });
          }}
          option={taskRiskRankType}
          Style="select-block"
        />

        <!-- Priority filter -->
        <DropDown
          showIcon={true}
          checkbox={true}
          deleteSelected={true}
          titleChanged={false}
          active={true}
          title="Priority"
          checkedFields="checked"
          removeIcon={true}
          on:onClear={(event) => {
            extraFilter.priority = [];
          }}
          on:onSelect={(item) => {
            extraFilter.priority = item.detail;
          }}
          option={configPriority}
          Style="select-block"
        />
        <button
          type="button"
          class="p-0 reset-filter color-blue d-flex flex-row align-items-center text-start ms-1 bg-transparent border-0"
          on:click={() => {
            resetFilter();
          }}
        >
          <img
            class="icon-14 me-2"
            alt=""
            src="/images/reset.svg"
          />
          Reset Filter
        </button>
        <!-- <div class="ms-1 me-2">
				  <ReportFilter
				  showSaveButton={filterButton}
				  filter={extraFilter}
				  type={2}
				  on:onSave={(item)=>{
					filterButton=false;
				  }}
				  />
				</div> -->
      </div>
    </div>

    <div
      class="right-action-content schedule-task-right d-flex justify-content-end align-items-center"
    >
      <span class="text-nowrap me-1"
        >{totalRecords > 0 && totalCount > 0
          ? '(' + totalCount + ' of ' + totalRecords + ' Tasks)'
          : ''}</span
      >
      {#if columnLoaded}
        <DropDown
          dropDownStyle={' dropdown-menu-end right-position'}
          checkbox={true}
          active={false}
          title="Fields"
          option={allColumns.filter((item) => item.key !== 'id')}
          labelFields="label"
          checkedFields="checked"
          Style="select-block"
          on:onSelect={(item) => {
            let oldColumns = [];
            let hiddenColumn = [];
            for (var i in allColumns) {
              if (allColumns[i].key == 'id') {
                oldColumns.push(idObj);
                allColumns[i].checked = true;
              } else if (searchKeyByValue(item.detail, 'key', allColumns[i].key) !== -1) {
                oldColumns.push(allColumns[i]);
                allColumns[i].checked = true;
              } else {
                hiddenColumn.push(allColumns[i]);
                allColumns[i].checked = false;
              }
            }
            setTimeout(() => {
              initPopupOver();
            }, 500);
            columns = oldColumns;
            client.taskScheduleGridColumnSave({ columns: allColumns });
            setColumnUnitWidth();
          }}
        />
      {/if}
      <div
        class="btn-group btn-group-sm btn-view-type"
        role="group"
        aria-label="Basic example"
      >
        <ul
          class="nav nav-tabs btn-calendar-view calendar-view-tabs"
          id="myTab2"
          role="tablist"
        >
          <li
            class="nav-item"
            role="presentation"
          >
            <a
              class="nav-link active rounded"
              id="home-tab2"
              on:click={() => {
                showBulkOption = true;
                // firstTimeGridLoad=true
                calenderButton = false;
                extraFilter.comeFrom = '';
                dashboardLeftObj.setTabIndex(1);
                showLink('list');
              }}
              data-bs-toggle="tab"
              href="#home2"
              role="tab"
              aria-controls="home"
              aria-selected="true"
            >
              <svg
                version="1.1"
                id="Capa_1"
                x="0px"
                y="0px"
                viewBox="0 0 343.5 343.5"
                style="enable-background:new 0 0 343.5 343.5;"
                xml:space="preserve"
                ><g
                  ><g
                    ><path
                      d="M322.05,161.8h-182.6c-5.5,0-10,4.5-10,10s4.5,10,10,10h182.6c5.5,0,10-4.5,10-10C332.05,166.3,327.65,161.8,322.05,161.8 z"
                    /></g
                  ></g
                ><g
                  ><g
                    ><path
                      d="M57.95,125.3c-25.7,0-46.5,20.8-46.5,46.5s20.8,46.5,46.5,46.5s46.5-20.8,46.5-46.5S83.65,125.3,57.95,125.3z			 M57.95,198.3c-14.7,0-26.5-11.9-26.5-26.5c0-14.7,11.9-26.5,26.5-26.5c14.6,0,26.5,11.9,26.5,26.5S72.55,198.3,57.95,198.3z"
                    /></g
                  ></g
                ><g>
                  <g>
                    <path
                      d="M322.05,36.8h-182.6c-5.5,0-10,4.5-10,10s4.5,10,10,10h182.6c5.5,0,10-4.5,10-10C332.05,41.3,327.65,36.8,322.05,36.8z"
                    /></g
                  ></g
                ><g>
                  <g>
                    <path
                      d="M57.95,0c-25.7,0-46.5,20.8-46.5,46.5c0,25.7,20.8,46.5,46.5,46.5s46.5-20.8,46.5-46.5C104.45,20.9,83.65,0.1,57.95,0z			 M57.95,73.1c-14.7,0-26.5-11.9-26.5-26.5c0-14.6,11.9-26.5,26.5-26.5c14.7,0,26.5,11.9,26.5,26.5			C84.45,61.2,72.55,73.1,57.95,73.1z"
                    />
                  </g></g
                ><g
                  ><g>
                    <path
                      d="M322.05,286.8h-182.6c-5.5,0-10,4.5-10,10s4.5,10,10,10h182.6c5.5,0,10-4.5,10-10S327.65,286.8,322.05,286.8z"
                    /></g
                  ></g
                ><g
                  ><g
                    ><path
                      d="M57.95,250.5c-25.7,0-46.5,20.8-46.5,46.5c0,25.7,20.8,46.5,46.5,46.5s46.5-20.8,46.5-46.5 C104.45,271.4,83.65,250.5,57.95,250.5z M57.95,323.6c-14.7,0-26.5-11.9-26.5-26.5c0-14.7,11.9-26.5,26.5-26.5 c14.7,0,26.5,11.9,26.5,26.5S72.55,323.6,57.95,323.6z"
                    /></g
                  ></g
                ></svg
              >
            </a>
          </li>
          <li
            class="nav-item"
            role="presentation"
          >
            <a
              class="nav-link rounded"
              id="profile-tab2"
              data-bs-toggle="tab"
              on:click={() => {
                firstTimeCalendarLoad = true;
                extraFilter.comeFrom = 'calender';
                calenderButton = true;
                showBulkOption = false;
                extraFilter.recurringType = '';
                dashboardLeftObj.setTabIndex(1, 'calender');
                if (calendarComponentRef != undefined) {
                  calendarComponentRef.updateSize();
                }
                showLink('calender');
              }}
              href="#profile2"
              role="tab"
              aria-controls="profile"
              aria-selected="false"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="512"
                height="512"
                viewBox="0 0 128 128"
                ><g
                  ><path
                    d="M120.25,23.507h-5.625V14.374a5.756,5.756,0,0,0-5.75-5.75h-4.034a5.756,5.756,0,0,0-5.75,5.75v9.133H86.053V14.374a5.756,5.756,0,0,0-5.75-5.75H76.269a5.757,5.757,0,0,0-5.75,5.75v9.133H57.481V14.374a5.757,5.757,0,0,0-5.75-5.75H47.7a5.757,5.757,0,0,0-5.75,5.75v9.133H28.909V14.374a5.757,5.757,0,0,0-5.75-5.75H19.125a5.757,5.757,0,0,0-5.75,5.75v9.133H7.75A7.759,7.759,0,0,0,0,31.257v81.369a6.758,6.758,0,0,0,6.75,6.75h114.5a6.758,6.758,0,0,0,6.75-6.75V31.257A7.759,7.759,0,0,0,120.25,23.507Zm-17.659-9.133a2.253,2.253,0,0,1,2.25-2.25h4.034a2.253,2.253,0,0,1,2.25,2.25v9.133h-8.534Zm-28.572,0a2.253,2.253,0,0,1,2.25-2.25H80.3a2.253,2.253,0,0,1,2.25,2.25v9.133H74.019Zm-28.572,0a2.253,2.253,0,0,1,2.25-2.25h4.034a2.253,2.253,0,0,1,2.25,2.25v9.133H45.447Zm-28.572,0a2.253,2.253,0,0,1,2.25-2.25h4.034a2.253,2.253,0,0,1,2.25,2.25v9.133H16.875ZM3.5,31.257a4.255,4.255,0,0,1,4.25-4.25h112.5a4.254,4.254,0,0,1,4.25,4.25V42.635H3.5Zm121,81.369a3.254,3.254,0,0,1-3.25,3.25H6.75a3.254,3.254,0,0,1-3.25-3.25V46.135h121Z"
                  /><path
                    d="M13.75,68.063H24.486a3.755,3.755,0,0,0,3.75-3.75V56.385a3.754,3.754,0,0,0-3.75-3.75H13.75A3.754,3.754,0,0,0,10,56.385v7.928A3.755,3.755,0,0,0,13.75,68.063ZM13.5,56.385a.25.25,0,0,1,.25-.25H24.486a.25.25,0,0,1,.25.25v7.928a.251.251,0,0,1-.25.25H13.75a.251.251,0,0,1-.25-.25Z"
                  /><path
                    d="M43.671,68.063H54.407a3.755,3.755,0,0,0,3.75-3.75V56.385a3.754,3.754,0,0,0-3.75-3.75H43.671a3.754,3.754,0,0,0-3.75,3.75v7.928A3.755,3.755,0,0,0,43.671,68.063Zm-.25-11.678a.251.251,0,0,1,.25-.25H54.407a.25.25,0,0,1,.25.25v7.928a.251.251,0,0,1-.25.25H43.671a.251.251,0,0,1-.25-.25Z"
                  /><path
                    d="M73.593,68.063H84.329a3.755,3.755,0,0,0,3.75-3.75V56.385a3.755,3.755,0,0,0-3.75-3.75H73.593a3.754,3.754,0,0,0-3.75,3.75v7.928A3.755,3.755,0,0,0,73.593,68.063Zm-.25-11.678a.25.25,0,0,1,.25-.25H84.329a.25.25,0,0,1,.25.25v7.928a.251.251,0,0,1-.25.25H73.593a.251.251,0,0,1-.25-.25Z"
                  /><path
                    d="M103.514,68.063H114.25a3.755,3.755,0,0,0,3.75-3.75V56.385a3.755,3.755,0,0,0-3.75-3.75H103.514a3.754,3.754,0,0,0-3.75,3.75v7.928A3.755,3.755,0,0,0,103.514,68.063Zm-.25-11.678a.25.25,0,0,1,.25-.25H114.25a.25.25,0,0,1,.25.25v7.928a.251.251,0,0,1-.25.25H103.514a.251.251,0,0,1-.25-.25Z"
                  /><path
                    d="M13.75,88.719H24.486a3.755,3.755,0,0,0,3.75-3.75V77.041a3.755,3.755,0,0,0-3.75-3.75H13.75A3.755,3.755,0,0,0,10,77.041v7.928A3.755,3.755,0,0,0,13.75,88.719ZM13.5,77.041a.25.25,0,0,1,.25-.25H24.486a.25.25,0,0,1,.25.25v7.928a.251.251,0,0,1-.25.25H13.75a.251.251,0,0,1-.25-.25Z"
                  /><path
                    d="M43.671,88.719H54.407a3.755,3.755,0,0,0,3.75-3.75V77.041a3.755,3.755,0,0,0-3.75-3.75H43.671a3.755,3.755,0,0,0-3.75,3.75v7.928A3.755,3.755,0,0,0,43.671,88.719Zm-.25-11.678a.251.251,0,0,1,.25-.25H54.407a.25.25,0,0,1,.25.25v7.928a.251.251,0,0,1-.25.25H43.671a.251.251,0,0,1-.25-.25Z"
                  /><path
                    d="M73.593,88.719H84.329a3.755,3.755,0,0,0,3.75-3.75V77.041a3.755,3.755,0,0,0-3.75-3.75H73.593a3.755,3.755,0,0,0-3.75,3.75v7.928A3.755,3.755,0,0,0,73.593,88.719Zm-.25-11.678a.25.25,0,0,1,.25-.25H84.329a.25.25,0,0,1,.25.25v7.928a.251.251,0,0,1-.25.25H73.593a.251.251,0,0,1-.25-.25Z"
                  /><path
                    d="M103.514,88.719H114.25a3.755,3.755,0,0,0,3.75-3.75V77.041a3.755,3.755,0,0,0-3.75-3.75H103.514a3.755,3.755,0,0,0-3.75,3.75v7.928A3.755,3.755,0,0,0,103.514,88.719Zm-.25-11.678a.25.25,0,0,1,.25-.25H114.25a.25.25,0,0,1,.25.25v7.928a.251.251,0,0,1-.25.25H103.514a.251.251,0,0,1-.25-.25Z"
                  /><path
                    d="M13.75,109.376H24.486a3.755,3.755,0,0,0,3.75-3.75V97.7a3.755,3.755,0,0,0-3.75-3.75H13.75A3.755,3.755,0,0,0,10,97.7v7.928A3.755,3.755,0,0,0,13.75,109.376ZM13.5,97.7a.25.25,0,0,1,.25-.25H24.486a.25.25,0,0,1,.25.25v7.928a.25.25,0,0,1-.25.25H13.75a.25.25,0,0,1-.25-.25Z"
                  /><path
                    d="M43.671,109.376H54.407a3.755,3.755,0,0,0,3.75-3.75V97.7a3.755,3.755,0,0,0-3.75-3.75H43.671a3.755,3.755,0,0,0-3.75,3.75v7.928A3.755,3.755,0,0,0,43.671,109.376ZM43.421,97.7a.251.251,0,0,1,.25-.25H54.407a.25.25,0,0,1,.25.25v7.928a.25.25,0,0,1-.25.25H43.671a.251.251,0,0,1-.25-.25Z"
                  /><path
                    d="M86.816,94.905a1.75,1.75,0,0,0-2.453.328l-7.3,9.544-4.1-5.177a1.749,1.749,0,1,0-2.742,2.173l5.5,6.94a1.749,1.749,0,0,0,1.371.663h.015a1.753,1.753,0,0,0,1.375-.687l8.66-11.331A1.749,1.749,0,0,0,86.816,94.905Z"
                  /><path
                    d="M116.737,94.905a1.75,1.75,0,0,0-2.453.328l-7.294,9.544-4.1-5.177a1.749,1.749,0,1,0-2.742,2.173l5.5,6.94a1.751,1.751,0,0,0,1.372.663h.015a1.753,1.753,0,0,0,1.375-.687l8.659-11.331A1.75,1.75,0,0,0,116.737,94.905Z"
                  /></g
                ></svg
              >
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div class="page-content table-content p-0">
  <!-- <button on:click={()=>{
			let oldColumns=[...columns]
			oldColumns.splice(0,1)
			columns=oldColumns
		  }}>done</button> -->
  <div
    class="tab-content h-100 d-flex flex-column p-3 full-calendar"
    id="myTabContent2"
  >
    <div
      class="tab-pane page-content fade show page-content tasklist-content active"
      id="home2"
      role="tabpanel"
      aria-labelledby="home-tab2"
      bind:this={scrollRef}
    >
      <DataTable
        bind:this={datatableRef}
        columns={columns}
        scrollRef={scrollRef}
        getData={getData}
        datatableCallback={(state) => {
          if (checkBoxSelected) {
            selectedTasks = [
              ...(selectedTasks || []),
              ...(state?.value?.[state.pageNumber] || [])?.map((item) => ({
                id: item.id,
                unitId: item.unitId,
              })),
            ];
          }
          console.log('sheduled list');
          setTimeout(() => {
            initPopupOver();
          }, 500);
        }}
        let:row
      >
        {#if searchKeyByValue(columns, 'key', 'id') !== -1}
          <td class="text-muted">
            <div class="checkbox c-checkbox">
              <label>
                <input
                  type="checkbox"
                  checked={checkBoxSelected}
                  name="live_bidding"
                  on:change={(event) => {
                    let oldSelectedTasks = selectedTasks;
                    if (event.target.checked) {
                      oldSelectedTasks.push({ id: row.id });
                    } else {
                      oldSelectedTasks.splice(searchKeyByValue(selectedTasks, 'id', row.id), 1);
                    }
                    selectedTasks = oldSelectedTasks;
                  }}
                  value="1"
                />
                <span class="check-img"></span>
              </label>
            </div>
          </td>
        {/if}
        {#if searchKeyByValue(columns, 'key', 'priority') !== -1}
          <td
            class="text-muted"
            width="20"
          >
            <DropDown
              showTitle={false}
              showIcon={true}
              checkbox={false}
              deleteSelected={false}
              active={true}
              titleChanged={true}
              value={row.priority}
              extraClass={getValueBySearchValue(
                configItem.priority,
                'id',
                row.priority,
                'extraClass',
              )}
              icon={getValueBySearchValue(configItem.priority, 'id', row.priority, 'icon')}
              title={getValueBySearchValue(configItem.priority, 'id', row.priority, 'name')}
              defaultTitle="Priority"
              on:onSelect={(item) => {
                client
                  .taskChangePriority({
                    priority: item.detail.id,
                    tasks: [{ id: row.id }],
                  })
                  .then(async (result) => {
                    if (
                      extraFilter.priority.length > 0 &&
                      extraFilter.priority.filter((iitem) => iitem.id == item.detail.id).length == 0
                    ) {
                      selectedTasks = [];
                      filterData();
                    }
                    datatableRef.changeData({ id: row.id, priority: item.detail.id }, 'id');
                  });
              }}
              option={configItem.priority}
              Style="select-block priority-dropdown"
            />
          </td>
        {/if}

        <!-- Risk rwank column scheduled -->
        {#if searchKeyByValue(columns, 'key', 'riskRank') !== -1}
          <td
            class="text-muted"
            width="20"
          >
            <DropDown
              showTitle={false}
              showIcon={true}
              checkbox={false}
              deleteSelected={false}
              active={true}
              titleChanged={true}
              value={row.riskRank}
              extraClass={getValueBySearchValue(
                configItem.riskRank,
                'id',
                row.riskRank,
                'extraClass',
              )}
              icon={getValueBySearchValue(configItem.riskRank, 'id', row.riskRank, 'icon')}
              title={getValueBySearchValue(configItem.riskRank, 'id', row.riskRank, 'name')}
              defaultTitle="Risk Rank"
              on:onSelect={(item) => {
                client
                  .taskRiskRank({
                    riskRank: item.detail.id,
                    tasks: [{ id: row.id }],
                  })
                  .then(() => {
                    if (
                      !!extraFilter.taskRiskRankType.length &&
                      !extraFilter.taskRiskRankType?.find?.((fItem) => fItem.id === item.detail.id)
                    ) {
                      selectedTasks = [];
                      filterData();
                    }
                    datatableRef.changeData(
                      {
                        id: row.id,
                        riskRank: item.detail.id,
                      },
                      'id',
                    );
                  });
              }}
              option={configItem.riskRank}
              Style="select-block risk-rank-dropdown"
            />
          </td>
        {/if}
        {#if searchKeyByValue(columns, 'key', 'unitName') !== -1}
          <td class="text-muted">{row.unitName}</td>
        {/if}

        {#if searchKeyByValue(columns, 'key', 'name') !== -1}
          <td class="text-muted text-nowrap">
            <button
              type="button"
              class="bg-transparent border-0 color-blue text-start text-break px-0 clone_popup"
              data-bs-placement="top"
              data-bs-toggle="popover"
              data-bs-trigger="hover focus"
              data-bs-content={row.name +
                (row.parentId > 0 ? ' (Sub task of: ' + row.parentName + ')' : '')}
              on:click={() => {
                var elements = document.querySelectorAll('.popover.show');
                elements.forEach(function (el) {
                  el.remove();
                });
                editTask(row.id);
              }}
            >
              <span
                class="column-unit-name"
                style="max-width:{availableWidth}px">{row.name}</span
              >
              {#if row.subTaskCount > 0}
                <img
                  alt=""
                  class="icon-14 ms-2 me-1"
                  src="/images/checklist.svg"
                />
                <span class="align-middle position-relative sub-task-count">{row.subTaskCount}</span
                >
              {/if}
              {#if row.parentId > 0}
                <img
                  alt=""
                  class="icon-14 ms-2 me-1"
                  src="/images/subtask.svg"
                />
              {/if}
            </button>
          </td>
        {/if}

        {#if searchKeyByValue(columns, 'key', 'purpose') !== -1}
          <td class="text-muted">
            <button
              type="button"
              class="bg-transparent border-0 text-start text-break px-0 clone_popup"
              data-bs-placement="top"
              data-bs-toggle="popover"
              data-bs-trigger="hover focus"
              data-bs-content={row.purpose}
              on:click={() => {
                var elements = document.querySelectorAll('.popover.show');
                elements.forEach(function (el) {
                  el.remove();
                });
                editTask(row.id);
              }}
            >
              <span
                class="column-unit-name"
                style="max-width:{availableWidth}px">{row.purpose}</span
              >
            </button>
          </td>
        {/if}
        {#if searchKeyByValue(columns, 'key', 'requirement') !== -1}
          <td class="text-muted">
            <button
              type="button"
              class="bg-transparent border-0 text-start text-break px-0 {row.requirement != ''
                ? 'clone_popup'
                : ''}"
              data-bs-placement="top"
              data-bs-toggle="popover"
              data-bs-trigger="hover focus"
              data-bs-content={row.requirement}
              on:click={() => {
                var elements = document.querySelectorAll('.popover.show');
                elements.forEach(function (el) {
                  el.remove();
                });
                editTask(row.id);
              }}
            >
              <span
                class="column-unit-name"
                style="max-width:{availableWidth}px">{row.requirement}</span
              >
            </button>
          </td>
        {/if}
        {#if searchKeyByValue(columns, 'key', 'responsibleParty') !== -1}
          <td class="text-muted">{extraFilter.taskType == 2 ? '' : row.responsiblePartyLabel}</td>
        {/if}
        {#if searchKeyByValue(columns, 'key', 'assigneeUserName') !== -1}
          <td class="text-muted">{row.assigneeUserName}</td>
        {/if}
        {#if searchKeyByValue(columns, 'key', 'clientName') !== -1}
          <td class="text-muted">
            <button
              type="button"
              class="bg-transparent border-0 color-blue text-start"
              on:click={() => {
                showClientModal(row.clientId);
              }}
            >
              {row.clientName}
            </button>
          </td>
        {/if}
        {#if searchKeyByValue(columns, 'key', 'clientFundProfileName') !== -1}
          <td class="text-muted">
            <button
              type="button"
              class="bg-transparent border-0 color-blue text-start"
              on:click={() => {
                showClientModal(row.clientId, row.clientFundProfileId);
              }}
            >
              {row.clientFundProfileName}
            </button>
          </td>
        {/if}
        {#if searchKeyByValue(columns, 'key', 'recurring') !== -1}
          <td class="text-muted">{row.recurringLabel}</td>
        {/if}
        {#if searchKeyByValue(columns, 'key', 'unitProjectName') !== -1}
          <td class="text-muted">{row.unitProjectName}</td>
        {/if}

        {#if searchKeyByValue(columns, 'key', 'openDate') !== -1}
          <td
            class="text-muted text-nowrap"
            width="130"
          >
            <button
              class="form-control input taskdate {searchKeyByValue(
                heighlightTaskIds,
                'id',
                row.id,
              ) !== -1
                ? 'shake-column'
                : ''}"
              on:click={() =>
                openDueDateModal.show({
                  comeFrom: 'list',
                  dateType: 'openDate',
                  date: row.openDateDb,
                  tasks: [{ id: row.id }],
                })}
            >
              <img
                class="img-calendar icon-16"
                alt=""
                src="/images/calendar.svg"
              />
              {row.openDate}
            </button>
          </td>
        {/if}
        {#if searchKeyByValue(columns, 'key', 'dueDate') !== -1}
          <td
            class="text-muted text-nowrap"
            width="130"
          >
            <button
              class="form-control input taskdate {searchKeyByValue(
                heighlightTaskIds,
                'id',
                row.id,
              ) !== -1
                ? 'shake-column'
                : ''}"
              on:click={() =>
                openDueDateModal.show({
                  comeFrom: 'list',
                  dateType: 'dueDate',
                  date: row.dueDateDb,
                  tasks: [{ id: row.id }],
                })}
            >
              <img
                class="img-calendar icon-16"
                alt=""
                src="/images/calendar.svg"
              />
              {row.dueDate}
            </button>
          </td>
        {/if}
        {#if searchKeyByValue(columns, 'key', 'status') !== -1}
          <td
            class="text-muted status-pill"
            width="90"
          >
            <span class="td-status-3">{row.statusLabel}</span>
          </td>
        {/if}

        <!-- Compliance status - should be always Pending, pending_id === 2 -->
        {#if searchKeyByValue(columns, 'key', 'complianceStatus') !== -1}
          <td
            class="text-muted status-pill"
            width="90"
          >
            <span class="td-compliance-2"
              >{configItem.allComplianceStatus.find((item) => item.id === 2).name}</span
            >
          </td>
        {/if}

        {#if searchKeyByValue(columns, 'key', 'clone') !== -1}
          <td class="text-muted">
            <button
              type="button"
              data-bs-placement="top"
              data-bs-toggle="popover"
              data-bs-trigger="hover focus"
              data-bs-content="clone"
              class="bg-transparent border-0 color-blue clone_popup"
              on:click={() => {
                showDialog({
                  type: 'confirm',
                  title: '',
                  message: 'Are you sure ?',
                  okFunc: () => {
                    client.taskClone({ id: row.id }).then(async (result) => {
                      selectedTasks = [];
                      filterData();
                      editTask(result.data.taskId, 'clone');
                    });
                  },
                });
              }}
            >
              <img
                class="icon-16"
                alt=""
                src="/images/copy.svg"
              />
            </button>
          </td>
        {/if}
      </DataTable>
    </div>

    <div
      class="tab-pane page-content h-100 fade"
      id="profile2"
      role="tabpanel"
      aria-labelledby="profile-tab2"
    >
      {#if extraFilter.comeFrom == 'calender'}
        <FullCalendar
          initialView={initialView}
          events={getEvents}
          extraFilter={extraFilter}
          eventClick={(info) => {
            if (info.event.extendedProps.yearViewDate) {
              calendarComponentRef.setInitialView(
                'dayGridMonth',
                info.event.extendedProps.yearViewDate,
                info.event.extendedProps.assigneeUserId,
              );
            } else {
              editTask(info.event.extendedProps.id);
            }
          }}
          on:moreLinkClick={(e) => handleMoreLinkClick(e.detail)}
          bind:this={calendarComponentRef}
        ></FullCalendar>
      {/if}
    </div>
  </div>
</div>

<!-- Library popover replacement -->
<svelte:window
  on:click={(e) => {
    if (
      moreEventsPopover &&
      !e.target.closest('.fc-custom-more-popover') &&
      !e.target.closest('.fc-more-link')
    ) {
      closeMoreEventsPopover();
    }
  }}
/>

{#if moreEventsPopover}
  <div
    class="fc-popover fc-more-popover fc-custom-more-popover"
    style="position:fixed;top:{moreEventsPopover.y}px;left:{moreEventsPopover.x}px;z-index:9999;background:#fff;border:1px solid #ddd;box-shadow:0 2px 6px rgba(0,0,0,.15);"
  >
    <div
      class="fc-popover-header"
      style="display:flex;flex-direction:row;justify-content:space-between;align-items:center;padding:3px 4px;background:rgba(208,208,208,0.3);"
    >
      <span class="fc-popover-title">Events</span>

      <span
        class="fc-popover-close"
        role="button"
        tabindex="0"
        style="cursor:pointer;opacity:0.65;font-size:1.1em;padding:0 4px;"
        on:click={closeMoreEventsPopover}
        on:keydown={(e) => e.key === 'Enter' && closeMoreEventsPopover()}>&times;</span
      >
    </div>

    <div
      class="fc-popover-body"
      style="min-width:220px;padding:10px;max-height:260px;overflow-y:auto;"
    >
      {#each moreEventsPopover.hiddenEvents as event}
        <button
          type="button"
          class="fc-daygrid-event fc-event {event.classNames.join(' ')}"
          style="display:flex;align-items:center;width:100%;text-align:left;background:#fff;border:1px solid #ddd;border-radius:3px;font-size:.85em;padding:2px 6px;margin-bottom:3px;cursor:pointer;white-space:nowrap;overflow:hidden;max-width:100%;"
          on:click={() => {
            closeMoreEventsPopover();
            editTask(event.extendedProps.id);
          }}
        >
          <span
            class="fc-event-main fc-event-title"
            style="overflow:hidden;text-overflow:ellipsis;">{event.title}</span
          >
        </button>
      {/each}
    </div>
  </div>
{/if}

<AddTaskModal bind:this={addTaskModal} />
<EditTaskModal bind:this={editTaskModal} />

<TaskReasonModal
  bind:this={taskReasonModal}
  handleClick={(params) => {
    //delete task
    if (selectedTypeId == 2) {
      client
        .taskDelete({
          tasks: selectedTasks,
          reason: params.reason,
          assignType,
          comeFrom: comeFromDetail ? 'detail' : '',
        })
        .then(async (result) => {
          selectedTasks = [];
          filterData();
          if (editTaskModal != undefined) {
            editTaskModal.hide();
          }
        })
        .catch((err) => {
          showDialog({ message: err.message });
        });
    }
    //comeplete task
    if (selectedTypeId == 3) {
      client
        .taskComplete({ tasks: selectedTasks, notes: params.reason })
        .then(async (result) => {
          selectedTasks = [];
          filterData();
        })
        .catch((err) => {
          showDialog({ message: err.message });
        });
    }
  }}
/>

<TaskChangeAssignee
  bind:this={taskChangeAssigneeModal}
  handleClick={(params) => {
    client
      .taskChangeAssignee({
        tasks: selectedTasks,
        assigneeUserId: params.assigneeUserId,
        reason: params.reason,
        assignType,
      })
      .then(async (result) => {
        selectedTasks = [];
        filterData();
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
  }}
/>

<OpenDueDateModal
  requestFrom="scheduleList"
  bind:this={openDueDateModal}
  success={() => {
    filterData();
  }}
/>

<ChangePriorityModal
  bind:this={changePriorityModal}
  success={(params) => {
    filterData();
  }}
/>

<!-- Risk Rank modal -->
<ChangeRiskRankModal
  bind:this={changeRiskRankModal}
  success={() => filterData()}
/>

<style>
  .btn-view-type {
    flex: 0 0 80px;
    max-width: 80px;
  }
  .top-menu-filter {
    border-bottom: 1px solid $input-border-color;
    padding: 0.5rem 1rem;
  }

  .right-action-content {
    display: flex;
    flex: 0 0 203px;
    min-width: 203px;
  }

  .btn-calendar-view {
    svg {
      width: 20px;
      height: 20px;
      fill: #656d77;
    }
  }

  .calendar-view-tabs {
    border: 0px;

    .active {
      border: 0px;
      background-color: rgba($input-border-color, 0.3);
      svg {
        fill: $blue-color;
      }
    }
    a {
      padding: 8px 10px;
      border: 0px;
      &:active {
        border: 0px;
      }
      &:focus {
        border: 0px;
      }
      &:hover {
        border: 0px;
      }
    }
  }
</style>
